import counterpart from 'counterpart'
import {setLocale} from 'reducers/locale'

const translations = {
  cn: require('../../assets/locale/zh_CN.js'),
  en: require('../../assets/locale/en_US.js')
}

const locales = Object.keys(translations)

let currentLocale
let savedLocale = localStorage.getItem('locale') || typeof (localStorage.getItem('locale')) === "undefined" ? "cn" : localStorage.getItem("locale")
const registerLocales = (store) => {
  locales.forEach(key => {
    counterpart.registerTranslations(key, translations[key])
  })
  store.subscribe(() => {
    let previousLocale = currentLocale
    currentLocale = store.getState().locale.currentLocale
    if (previousLocale !== currentLocale) {
      localStorage.setItem('locale', currentLocale)
      counterpart.setLocale(currentLocale)
    }
  })
  store.dispatch(setLocale(savedLocale))
  return savedLocale
}

export {
  locales,
  registerLocales
}
